import { render } from "./Pagination.vue?vue&type=template&id=749b2604&scoped=true&ts=true"
import script from "./Pagination.ts?vue&type=script&lang=ts"
export * from "./Pagination.ts?vue&type=script&lang=ts"

import "./Pagination.css?vue&type=style&index=0&id=749b2604&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749b2604"]])

export default __exports__